import { createSelector } from 'reselect';

import getLocationDeliveryEstimates from './getLocationDeliveryEstimates';

export default createSelector(
  [getLocationDeliveryEstimates],
  locationDeliveryEstimates => !!locationDeliveryEstimates.length,
);
